var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89671 0.982422C13.6128 0.982422 17.4497 4.81928 17.4497 9.53538C17.4497 14.2515 13.6128 18.0883 8.89671 18.0883C4.18061 18.0883 0.34375 14.2515 0.34375 9.53538C0.34375 4.81928 4.18061 0.982422 8.89671 0.982422ZM8.89671 2.26537C4.88794 2.26537 1.62669 5.52661 1.62669 9.53538C1.62669 13.5441 4.88794 16.8054 8.89671 16.8054C12.9055 16.8054 16.1667 13.5441 16.1667 9.53538C16.1667 5.52661 12.9055 2.26537 8.89671 2.26537ZM8.60693 5.34049C8.96188 5.34049 9.2484 5.62787 9.2484 5.98197V9.76408L12.1607 11.5003C12.4643 11.6825 12.5644 12.0759 12.3831 12.3804C12.2625 12.5814 12.0495 12.6935 11.8314 12.6935C11.7194 12.6935 11.6065 12.6644 11.503 12.6037L8.2785 10.6801C8.0852 10.5638 7.96546 10.3542 7.96546 10.1284V5.98197C7.96546 5.62787 8.25284 5.34049 8.60693 5.34049Z",
    fill: "#EDB82E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.c93617aae588f767a6d5c7437525b0d4.svg";
export { ForwardRef as ReactComponent };